import { ComponentType } from 'react';
import { StepMetadata } from './types';
import { STEP_LABELS } from './stepLabels';

// Step components and metadata
import { UploadFilesStep } from '../../components/DataFeedWizard/steps/UploadFilesStep/UploadFilesStep';
import { stepMetadata as uploadFilesMetadata } from '../../components/DataFeedWizard/steps/UploadFilesStep/config';
import {
  ConfigureMappingStep,
  stepMetadata as configureMappingMetadata,
} from '../../components/DataFeedWizard/steps/ConfigureMappingStep/ConfigureMappingStep';
import {
  LinkAccountsStep,
  stepMetadata as linkAccountsMetadata,
} from '../../components/DataFeedWizard/steps/LinkAccountsStep/LinkAccountsStep';
import {
  LinkInstrumentsStep,
  stepMetadata as linkInstrumentsMetadata,
} from '../../components/DataFeedWizard/steps/LinkInstrumentsStep/LinkInstrumentsStep';
import {
  LinkOTCStep,
  stepMetadata as linkOTCMetadata,
} from '../../components/DataFeedWizard/steps/LinkOTCStep/LinkOTCStep';
import {
  ReviewAndUploadStep,
  stepMetadata as reviewAndUploadMetadata,
} from '../../components/DataFeedWizard/steps/ReviewAndUploadStep/ReviewAndUploadStep';
import {
  PositionsMonitoringStep,
  stepMetadata as positionsMonitoringMetadata,
} from '../../components/DataFeedWizard/steps/PositionsMonitoringStep/PositionsMonitoringStep';

export interface WizardStepConfig {
  key: string;
  label: string;
  metadata: StepMetadata;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
}

// Step config - labels come from stepLabels.ts (single source of truth)
export const WIZARD_STEPS_CONFIG: WizardStepConfig[] = [
  {
    key: 'UPLOAD_FILES',
    label: STEP_LABELS[0],
    metadata: uploadFilesMetadata,
    component: UploadFilesStep,
  },
  {
    key: 'CONFIGURE_MAPPING',
    label: STEP_LABELS[1],
    metadata: configureMappingMetadata,
    component: ConfigureMappingStep,
  },
  {
    key: 'LINK_ACCOUNTS',
    label: STEP_LABELS[2],
    metadata: linkAccountsMetadata,
    component: LinkAccountsStep,
  },
  {
    key: 'LINK_INSTRUMENTS',
    label: STEP_LABELS[3],
    metadata: linkInstrumentsMetadata,
    component: LinkInstrumentsStep,
  },
  {
    key: 'LINK_OTC',
    label: STEP_LABELS[4],
    metadata: linkOTCMetadata,
    component: LinkOTCStep,
  },
  {
    key: 'REVIEW_AND_UPLOAD',
    label: STEP_LABELS[5],
    metadata: reviewAndUploadMetadata,
    component: ReviewAndUploadStep,
  },
  {
    key: 'POSITIONS_MONITORING',
    label: STEP_LABELS[6],
    metadata: positionsMonitoringMetadata,
    component: PositionsMonitoringStep,
  },
];

// Auto-generated enum based on array order
export enum WizardStep {
  UPLOAD_FILES = 0,
  CONFIGURE_MAPPING = 1,
  LINK_ACCOUNTS = 2,
  LINK_INSTRUMENTS = 3,
  LINK_OTC = 4,
  REVIEW_AND_UPLOAD = 5,
  POSITIONS_MONITORING = 6,
}

// Total number of steps
export const TOTAL_STEPS = WIZARD_STEPS_CONFIG.length;
